import React from 'react';
import { IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolume } from '@fortawesome/pro-light-svg-icons';
import MssTooltip from './MssTooltip';

export const AudioButton = ({ id = 'mss__iconButton_audio', text, label = 'Read aloud' }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    if (!text || !window.speechSynthesis) return;
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(new SpeechSynthesisUtterance(text));
  };

  return (
    <MssTooltip id={`${id}_tooltip`} title={label}>
      <IconButton
        id={id}
        className="toolbarIconButton"
        size="small"
        onClick={handleClick}
        aria-label={label}
      >
        <FontAwesomeIcon icon={faVolume} />
      </IconButton>
    </MssTooltip>
  );
};
